// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__5GNK9","boolean-row":"Details_boolean-row__1FJTd","col":"Details_col__2lk7m","row":"Details_row__3_40U"};